module.exports = __webpack_public_path__ + "img/menu.8b127c2a.svg";